import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import MeuPerfil from '../modals/meuPerfil'

const Layout = (props) => {

    var nomeUsuario = sessionStorage.getItem('nome')

    //permPaginas, permNoticias, permEventos, permDesafios, permAdesoes, permAdmin,


    var history = useHistory()




    function logout() {
        
        sessionStorage.clear()
        history.push('/')

    }


    return (
        <div>


            
                    <div id="wrapper" className="wrapper animsition">
                        
                        <nav className="navbar navbar-fixed-top">
                            <div className="navbar-header">
                                <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                                    <span className="sr-only">Toggle navigation</span>
                                    <i className="material-icons">apps</i>
                                </button>
                                <a className="navbar-brand" >
                                    <img className="main-logo" src="assets/dist/img/light-logo.png" id="bg" alt="" style={{ display: 'none'}}  />
                                    <img className="main-logo" src={process.env.PUBLIC_URL + '../assets/pics/logo_HS.png'} style={{ display: 'none'}} id="bg"  />
                                    
                                    
                                </a>
                            </div>
                            <div className="nav-container">

                                    
                                <ul>
                                    <table border="0">
                                        <tr>
                                            <td width="1%">
                                                <img className="main-logo" src={process.env.PUBLIC_URL + '../assets/pics/logo_HS.png'} style={{ width: '135px'}} id="bg"  />
                                                
                                            </td>
                                            <td>
                                                <div align="right">
                                                <Link onClick={() => window.$('#modalMeuPerfil').modal('show')}>{nomeUsuario}</Link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </div>
                                            </td>

                                        </tr>
                                    
                                    </table>
                                </ul>
                                

                                
                            </div>
                        </nav>
                        
                        <div className="sidebar" role="navigation">
                            <div className="sidebar-nav navbar-collapse">
                                <ul className="nav" id="side-menu">
                                    <li className="nav-heading "> <span>Menu</span></li>
                                    
                                    <li><Link to='/Dashboard' className="material-ripple"><i className="material-icons">home</i> Dashboard</Link></li>
                                    <li style={{ display: sessionStorage.getItem('permPaginas') == 'true' ? 'block' : 'none'}}><Link to='/Paginas' class="material-ripple"><i class="material-icons">invert_colors</i> Páginas e Conteúdos</Link></li>
                                    <li style={{ display: sessionStorage.getItem('permNoticias') == 'true' ? 'block' : 'none'}}><Link to='/Noticias' className="material-ripple"><i className="material-icons">bubble_chart</i> Notícias</Link></li>


                                    <li>
                                        <Link to='/Biblioteca' className="material-ripple"><i className="material-icons">drafts</i> Biblioteca</Link>
                                        
                                    </li>
                                  
                                    <li style={{ display: sessionStorage.getItem('permEventos') == 'true' ? 'block' : 'none'}}>
                                        <a href="#" className="material-ripple"><i className="material-icons">add_alert</i> Eventos<span className="fa arrow"></span></a>
                                        <ul className="nav nav-second-level">
                                            <li><Link to='/Eventos'>Administração</Link></li>
                                            <li><Link to='/Calendario'>Calendário</Link></li>
                                            
                                            
                                        </ul>
                                    </li>
                                    
                                    <li>
                                        <a href="#" className="material-ripple"><i className="material-icons">add_alert</i> Comunicação<span className="fa arrow"></span></a>
                                        <ul className="nav nav-second-level">
                                            <li><Link to='/FaleConosco'>Fale Conosco</Link></li>
                                            <li><Link to='/FiqueInformado'>Fique Informado</Link></li>
                                            
                                            
                                        </ul>
                                    </li>

                                    <li style={{ display: sessionStorage.getItem('permDesafios') == 'true' ? 'none' : 'none'}}>
                                        <a href="#" className="material-ripple"><i className="material-icons">business</i> Indicadores<span className="fa arrow"></span></a>
                                        <ul className="nav nav-second-level">
                                            <li><Link to='/Indicadores/DesafioClima'>Clima</Link></li>
                                            <li><Link to='/Indicadores/ResiduosSS'>Resíduos SS</Link></li>
                                            <li><Link to='/Indicadores/DesafioEnergia'>Energia</Link></li>
                                            <li><Link to='/Indicadores/DesafioCompras'>Compras</Link></li>
                                            
                                        </ul>
                                    </li>

                                    <li style={{ display: sessionStorage.getItem('permDesafios') == 'true' ? 'block' : 'none'}}>
                                        <a href="#" className="material-ripple"><i className="material-icons">business</i> Desafios<span className="fa arrow"></span></a>
                                        <ul className="nav nav-second-level">
                                            <li><Link to='/PerfilAnual'>Perfil Anual</Link></li>
                                            <li><Link to='/DesafioClima'>Clima</Link></li>
                                            <li><Link to='/ResiduosSS'>Resíduos SS</Link></li>
                                            <li><Link to='/DesafioEnergia'>Energia</Link></li>
                                            <li><Link to='/DesafioCompras'>Compras</Link></li>
                                            
                                        </ul>
                                    </li>
                                    
                                    <li style={{ display: sessionStorage.getItem('permAdesoes') == 'true' ? 'block' : 'none'}}>
                                        <a href="#" className="material-ripple"><i className="material-icons">assignment</i> Adesões<span className="fa arrow"></span></a>
                                        <ul className="nav nav-second-level">
                                            <li><Link to='/AdesaoIndividual'>Individuais</Link></li>
                                            <li><Link to='/AdesaoInstitucional'>Institucionais</Link></li>
                                            
                                        </ul>
                                    </li>


                                    <li style={{ display: 'none' }}>
                                        <Link to='/API' className="material-ripple"><i className="material-icons">insert_chart</i> API/BI</Link>
                                        
                                    </li>
                                    {
                                        /*

                                        <li >
                                            <Link to='/Manifesto' className="material-ripple"><i className="material-icons">insert_chart</i> Manifesto</Link>                                            
                                        </li>

                                        */
                                    }
                                    
                                    <li >
                                        <Link to='/GestaoMembros' className="material-ripple"><i className="material-icons">insert_chart</i> Gestão Membros</Link>
                                        
                                    </li>
                                    <li >
                                        <Link to='/HouseKeeper' className="material-ripple"><i className="material-icons">insert_chart</i> HouseKeeper</Link>
                                        
                                    </li>


                                    


                                    <li  style={{ display: sessionStorage.getItem('permAdmin') == 'true' ? 'block' : 'none'}}>
                                        <a href="#" className="material-ripple"><i className="material-icons">build</i> Administração<span className="fa arrow"></span></a>
                                        <ul className="nav nav-second-level">
                                            <li><Link to='/Usuarios'>Usuários</Link></li>
                                            <li><Link to='/Tokens'>Tokens API</Link></li>
                                            
                                            
                                        </ul>
                                    </li>

                                    <li><Link onClick={() => logout()} className="material-ripple"><i className="material-icons">bubble_chart</i> Sair</Link></li>
                                   
                                </ul>
                            </div>
                            
                        </div>
                        
                        <div className="side-bar right-bar">
                            <div className="">
                        
                                <ul className="nav nav-tabs right-sidebar-tabs" role="tablist">
                                    <li role="presentation" className="active"><a href="#home" aria-controls="home" role="tab" data-toggle="tab"><i className="material-icons">home</i></a></li>
                                    <li role="presentation"><a href="#profile" aria-controls="profile" role="tab" data-toggle="tab"><i className="material-icons">person_add</i></a></li>
                                    <li role="presentation"><a href="#messages" aria-controls="messages" role="tab" data-toggle="tab"><i className="material-icons">chat</i></a></li>
                                </ul>
                        
                                <div className="tab-content">
                                    <div role="tabpanel" className="tab-pane fade  in active" id="home">
                                        <ul id="styleOptions" title="switch styling">
                                            <li><b>Dark Skin</b></li>
                                            <li><a href="javascript: void(0)" data-theme="skin-blue.min"><img src="assets/dist/img/theme-color/1.jpg" alt=""/></a></li>
                                            <li><a href="javascript: void(0)" data-theme="skin-dark.min"><img src="assets/dist/img/theme-color/2.jpg" alt=""/></a></li>
                                            <li><a href="javascript: void(0)" data-theme="skin-red-light.min" className="skin-logo"><img src="assets/dist/img/theme-color/5.jpg" alt=""/></a></li>
                                            <li><b>Dark Skin sidebar</b></li>
                                            <li><a href="javascript: void(0)" data-theme="skin-default.min"><img src="assets/dist/img/theme-color/7.jpg" alt=""/> </a></li>
                                            <li><a href="javascript: void(0)" data-theme="skin-red-dark.min"><img src="assets/dist/img/theme-color/6.jpg" alt=""/></a></li>
                                            <li><a href="javascript: void(0)" data-theme="skin-dark-1.min"><img src="assets/dist/img/theme-color/8.jpg" alt=""/></a></li>
                                            <li><b>Light Skin sidebar</b></li>
                                            <li><a href="javascript: void(0)" data-theme="skin-default-light.min" className="skin-logo"><img src="assets/dist/img/theme-color/3.jpg" alt=""/></a></li>
                                            <li><a href="javascript: void(0)" data-theme="skin-white.min"><img src="assets/dist/img/theme-color/4.jpg" alt=""/></a> </li>
                                        </ul>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        
                        <div className="control-sidebar-bg"></div>
                        
                        <div id="page-wrapper">
                        
                            <div className="content">
                        
                                
                                

                                        {props.children}

                                        
                                    
                                
                            </div>
                        </div>
                    </div>
        


            <MeuPerfil />


        </div>
    )

}

export default Layout